import { useState } from 'react';

import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import Skeleton from '#client/components/Skeleton';

const CardAddress = ({ address, loading, children }) => {
  const [isEdit, setIsEdit] = useState(false);
  const { street, city, state, postalCode } = address;

  return (
    <>
      {!isEdit && (
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Stack gap="4px">
            <Text size="lg">{loading ? <Skeleton width={200} /> : street}</Text>
            <Text size="lg">
              {loading ? (
                <Skeleton
                  role="status"
                  width={200}
                />
              ) : (
                `${city}, ${state} ${postalCode}`
              )}
            </Text>
          </Stack>
          <Button
            color="info"
            disabled={loading}
            onClick={() => setIsEdit(true)}
            size="small"
            variant="text"
          >
            Edit
          </Button>
        </Stack>
      )}
      <Stack
        direction="column"
        display={isEdit ? 'flex' : 'none'}
        gap="16px"
      >
        {children}
      </Stack>
    </>
  );
};

CardAddress.propTypes = {
  address: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string
  }).isRequired,
  loading: PropTypes.bool,
  children: PropTypes.node
};

export default CardAddress;
